// test852
(852 && 0);
